import { defineComponent as h, computed as t, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as n, createCommentVNode as d, normalizeStyle as v } from "vue";
const f = ["viewBox"], _ = /* @__PURE__ */ e("mask", { id: "69617fc2-b639-4840-a151-b6d867bbe6f8" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#69617fc2-b639-4840-a151-b6d867bbe6f8)" }, u = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M0 0h512v385l-256 64L0 385z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#a2001d",
  d: "m375 97 23-24v24h23l-23 23 23 23h-23v23l-23-23-24 23v-23h-22l22-23-22-23h22V73zm-238 0 23-24v24h24l-24 23 24 23h-24v23l-23-23-23 23v-23H91l23-23-23-23h23V73zm119-50 23-23v23h23l-23 23 23 24h-23v23l-23-23-23 23V94h-23l23-24-23-23h23V24Z",
  class: "fil1"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#a2001d",
  d: "m218 103-35 35v28h-28l-35 35 29 29h20v38l17 17 32-32 11 11v121H0v127h512V385H282V264l11-11 32 32 17-17v-38h21l29-29-35-35-29 1v-29l-34-35-29 29v23l26 26-35 35-35-35 26-26v-23z",
  class: "fil1"
}, null, -1), b = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ h({
  __name: "ru-cu",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const l = r, o = t(() => 512 + 2 * l.strokeWidth), s = t(() => -l.strokeWidth), a = t(() => 256 + l.strokeWidth / 2);
    return (V, w) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      _,
      e("g", m, [
        l.flagName ? (i(), c("title", u, n(l.flagName), 1)) : d("", !0),
        k,
        p,
        g
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: v({ stroke: l.strokeColor, strokeWidth: l.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, f));
  }
});
export {
  z as default
};
//# sourceMappingURL=ru-cu-250cfba1.js.map
